import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../../store';

import { PassengersSegmentedCount } from '@ibe.models/passenger.model.indra.lib';
import { INDRAFeature } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';

import { EQUIPMENT_CODE_TRAIN,
		EQUIPMENT_CODE_BUS,
		ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, 
		SESSION_VAR_KEY_LANGUAGE,
		SESSION_VAR_KEY_MARKET,
		DEFAULT_MARKET,
		DEFAULT_LANGUAGE,
		SPECIAL_CASE_MARKET_LANGUAGE_MAP,
		AIRLINE_TAP_CODE,
		TP_EXPRESS_PORTUGALIA,
		SSR_CODE_FAST_TRACK} from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAFareInformation } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';

@Component({
	selector: 'app-flight-details-fast-track',
	templateUrl: './details-fast-track.indra.component.html',
	styleUrls: ['./details-fast-track.component.scss']
})
export class INDRAFlightDetailsFastTrackComponent implements OnInit, OnDestroy {

	flight;
	brand: string;
	feature: INDRAFeature;

	selectedStop: string;
	flightStop: any;
	directFlight: boolean = false;
	stops = [];
	isEligibleFlag: boolean = true;

	isAlive = true;

	passengers$: Observable<PassengersSegmentedCount> = this.store.select(fromStore.getMiniIBEPassengers);
	passengerList;

	reviewFlights: boolean = false;
	timeToThinkFlights: boolean = false;
	isUserFF: boolean = false;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>,
		private ancillariesService: INDRAAncillariesService,
		private bookingService: INDRABookingService,
		private bookingSearchService: INDRABookingSearchService,
		private storage: INDRAStorageService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService, 
		private bfmDataStorage: INDRABFMDataStorageService,
	) {
	}

	ngOnInit() {

		if (this.router.url.includes('/review-your-trip')) this.reviewFlights = true;
		if (this.router.url.includes('/time-to-think')) this.timeToThinkFlights = true;
		this.brand = this.route.snapshot.paramMap.get('brand');

		this.passengers$
			.pipe(takeWhile(() => this.isAlive))
				.subscribe(value => {
				if (value) {
					// generate generic passenger list according to type and count
					this.passengerList = this.ancillariesService.INDRA_generateGenericPassengerList(value);
				}
			});

		// Note: There are three flows where this sidebar will be shown - flight search result page, review your trip page, and in time to think page
		if (this.reviewFlights || this.timeToThinkFlights) {
			const flightIdentifier = this.route.snapshot.paramMap.get('flight');
			const flightObj = this.bookingService.INDRA_getBookedFlight(flightIdentifier);
			const origFlight = this.bookingService.INDRA_getFlightRoute(flightObj);
			this.flight = this.INDRA_getFlightRouteSegments(origFlight);
			this.feature = this.bookingService.INDRA_getIncludedFeature(
				ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, this.flight.idFlight.toString(), '');
		} else {
			// get flight and feature object from the data obj passed into the sidebarservice
			const parameters = this.sidebarService.getSidebarParameters();
			if (parameters && parameters.length) {
				this.flight = this.INDRA_getFlightRouteSegments(parameters[0].flightInfo);
				this.feature = parameters[0].feature;
			}
		}

		//fills input for segmented control radio
		for (let i = 0; i < this.flight.listSegment.length; i++) {
			const segment = this.flight.listSegment[i];
			this.stops.push({
				label: segment.departureAirport + '-' + segment.arrivalAirport,
				value: i
			});
		}

		if (!this.selectedStop) {
			this.INDRA_selectedStop(0);
		}
		this.directFlight = this.flight.listSegment.length > 1 ? false : true;

		this.INDRA_checkIfFrequentFlyerUser();
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_checkIfFrequentFlyerUser() {
		const userData = this.storage.get('userData');
		this.isUserFF = this.bookingSearchService.INDRA_isFrequentFlyerMember(userData);
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }


	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_printImage() {
		const IMAGE = 'fast_track.jpg';
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}



	/*
	 * 	For Fasttrack, since it is only being sold for the first segment,
	 * 	flight route should consist of the first 'flight' segment. Bus and Train segments are ignored.
	 */
	INDRA_getFlightRouteSegments(flight) {
		if (flight && flight.listSegment) {
			const flightSegments = flight.listSegment.filter(segment => {
				return (segment.equipment !== EQUIPMENT_CODE_TRAIN && segment.equipment !== EQUIPMENT_CODE_BUS);
			});

			if (flightSegments && flightSegments.length > 0) {
				const newFlightRouteInput = {
					listSegment: flightSegments,
					fareFamily: flight.fareFamily, // for review page flow
					options: { brand: this.brand }, // for flight search flow
					idFlight: flight.idFlight
				};
				return newFlightRouteInput;
			}
		}
		return flight;
	}


	INDRA_selectedStop(value) {
		if (!this.directFlight) {
			this.selectedStop = value;
			this.flightStop = this.flight.listSegment[this.selectedStop];			
		}
	}

	INDRA_isEligibleWithFastTrack() {
		this.isEligibleFlag = false;
		if (this.reviewFlights || this.timeToThinkFlights) {
			const fareInformation = this.bfmDataStorage.activeBooking['fare-information'];
			const flightIdfareInformation: INDRAFareInformation = fareInformation[this.flight.idFlight];
			const segmentAncillaries = flightIdfareInformation.ancillariesBySegment[this.flightStop.idInfoSegment];
			if (segmentAncillaries) {
				this.isEligibleFlag = segmentAncillaries.includes(SSR_CODE_FAST_TRACK);
			}
		} else {
			let fastTrackSegments = JSON.parse(sessionStorage.getItem('ancFastTrackSegments'));
			if (fastTrackSegments) {
				fastTrackSegments.forEach(segment => {
					if (segment.flightId === this.flight.idFlight && segment.idSegment === this.flightStop.idInfoSegment) {
						this.isEligibleFlag = true;
					}
				});
			}
		}

		return this.isEligibleFlag
	}

}
